export default __webpack_public_path__ + "static/media/second-block-bg.028aa6eb.png";